import React from 'react';
import { cenarios, siteConfig } from '../../data/mock';
import { MessageCircle, ArrowRight } from 'lucide-react';

const CenariosSection = () => {
  const whatsappLink = `https://wa.me/${siteConfig.whatsappNumber}?text=${encodeURIComponent(siteConfig.whatsappMessage)}`;

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-serif text-neutral-900 mb-4 whitespace-pre-line">
            <span className="text-[#c9a962]">Dois cenários</span> comuns quando existe{'\n'}conflito societário
          </h2>
        </div>
        
        {/* Comparison Cards */}
        <div className="grid lg:grid-cols-2 gap-8">
          {/* Cenario 1 - Negative */}
          <div className="group relative bg-white border-2 border-neutral-200 rounded-2xl overflow-hidden transition-all duration-500 hover:border-red-200 hover:shadow-xl hover:shadow-red-500/10">
            {/* Top accent */}
            <div className="h-2 bg-gradient-to-r from-red-400 to-red-600" />
            
            <div className="p-8 flex flex-col h-full">
              {/* Header */}
              <div className="flex items-center gap-4 mb-6">
                <div className="w-14 h-14 border-2 border-red-300 rounded-lg flex items-center justify-center">
                  <span className="text-red-500 font-serif text-2xl font-bold">1</span>
                </div>
                <h3 className="text-xl font-bold text-neutral-900">
                  {cenarios.cenario1.title}
                </h3>
              </div>
              
              {/* Intro text */}
              <div className="bg-neutral-50 border border-neutral-200 rounded-xl p-4 mb-6">
                <p className="text-neutral-600 leading-relaxed">
                  {cenarios.cenario1.intro}
                </p>
              </div>
              
              {/* Items */}
              <ul className="space-y-3 mb-6 flex-grow">
                {cenarios.cenario1.items.map((item, index) =>
                <li key={index} className="flex items-start gap-3">
                    <div className="mt-0.5 w-6 h-6 border-2 border-red-300 rounded flex items-center justify-center flex-shrink-0">
                      <svg className="w-3 h-3 text-red-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={3}>
                        <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                      </svg>
                    </div>
                    <span className="text-neutral-700">{item}</span>
                  </li>
                )}
              </ul>
              
              {/* Conclusion */}
              <div className="bg-red-50 border border-red-200 rounded-xl p-4 mt-auto">
                <p className="text-red-700 font-medium text-center">
                  {cenarios.cenario1.conclusion}
                </p>
              </div>
            </div>
          </div>
          
          {/* Cenario 2 - Positive */}
          <div className="group relative bg-white border-2 border-neutral-200 rounded-2xl overflow-hidden transition-all duration-500 hover:border-emerald-200 hover:shadow-xl hover:shadow-emerald-500/10">
            {/* Top accent */}
            <div className="h-2 bg-gradient-to-r from-emerald-400 to-emerald-600" />
            
            <div className="p-8 flex flex-col h-full">
              {/* Header */}
              <div className="flex items-center gap-4 mb-6">
                <div className="w-14 h-14 border-2 border-emerald-300 rounded-lg flex items-center justify-center">
                  <span className="text-emerald-500 font-serif text-2xl font-bold">2</span>
                </div>
                <h3 className="text-xl font-bold text-neutral-900">
                  {cenarios.cenario2.title}
                </h3>
              </div>
              
              {/* Intro text */}
              <div className="border border-neutral-200 !mb-[24px] !pt-[16px] !pb-[40px] !pl-[16px] !pr-[16px] rounded-xl bg-neutral-50">
                <p className="text-neutral-600 leading-relaxed">
                  {cenarios.cenario2.intro}
                </p>
              </div>
              
              {/* Items */}
              <ul className="space-y-3 mb-6 flex-grow">
                {cenarios.cenario2.items.map((item, index) =>
                <li key={index} className="flex items-start gap-3">
                    <div className="mt-0.5 w-6 h-6 border-2 border-emerald-300 rounded flex items-center justify-center flex-shrink-0">
                      <svg className="w-3 h-3 text-emerald-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={3}>
                        <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                      </svg>
                    </div>
                    <span className="text-neutral-700">{item}</span>
                  </li>
                )}
              </ul>
              
              {/* Conclusion */}
              <div className="bg-emerald-50 border border-emerald-200 rounded-xl p-4 mt-auto">
                <p className="text-emerald-700 font-medium text-center">
                  {cenarios.cenario2.conclusion}
                </p>
              </div>
            </div>
          </div>
        </div>
        
        {/* CTA Button - Below both cards */}
        <div className="text-center mt-12">
          <a
            href={whatsappLink}
            target="_blank"
            rel="noopener noreferrer"
            className="group inline-flex items-center justify-center gap-3 bg-emerald-600 hover:bg-emerald-500 text-white px-8 py-4 rounded-lg font-semibold text-lg transition-all duration-300 hover:scale-105 hover:shadow-xl hover:shadow-emerald-500/25">

            <MessageCircle className="w-5 h-5" />
            {siteConfig.ctaText}
            <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
          </a>
        </div>
      </div>
    </section>);

};

export default CenariosSection;